var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "task-detail" }, [
    _vm._m(0),
    _c("section", { staticClass: "base-info" }, [
      _c("div", { staticClass: "form" }, [
        _c(
          "div",
          { staticClass: "file" },
          [
            _c("span", { staticClass: "file-name" }, [_vm._v("课程：")]),
            _c(
              "el-select",
              {
                attrs: {
                  filterable: "",
                  placeholder: "请选择课程",
                  "value-key": "id",
                },
                on: { change: _vm.changeCourse },
                model: {
                  value: _vm.course,
                  callback: function ($$v) {
                    _vm.course = $$v
                  },
                  expression: "course",
                },
              },
              _vm._l(_vm.courseList, function (course) {
                return _c("el-option", {
                  key: course.id,
                  attrs: { label: course.name, value: course },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "file" },
          [
            _c("span", { staticClass: "file-name" }, [_vm._v("文件：")]),
            _c(
              "el-select",
              {
                attrs: {
                  filterable: "",
                  placeholder: "请选择文件",
                  "value-key": "id",
                  disabled: !_vm.course,
                },
                on: { change: _vm.changeFile },
                model: {
                  value: _vm.file,
                  callback: function ($$v) {
                    _vm.file = $$v
                  },
                  expression: "file",
                },
              },
              _vm._l(_vm.files, function (file) {
                return _c("el-option", {
                  key: file.id,
                  attrs: { label: file.name, value: file },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "file" },
          [
            _c("span", { staticClass: "file-name" }, [_vm._v("模板：")]),
            _c(
              "el-select",
              {
                attrs: { filterable: "", placeholder: "请选择模板（可选）" },
                model: {
                  value: _vm.templateId,
                  callback: function ($$v) {
                    _vm.templateId = $$v
                  },
                  expression: "templateId",
                },
              },
              _vm._l(_vm.templateList, function (template) {
                return _c("el-option", {
                  key: template.id,
                  attrs: { label: template.name, value: template.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("span", { staticClass: "task-name" }, [
              _vm._v("任务资源库名称："),
            ]),
            _c("el-input", {
              attrs: { placeholder: "请输入任务资源库名称" },
              model: {
                value: _vm.taskBase_name,
                callback: function ($$v) {
                  _vm.taskBase_name = $$v
                },
                expression: "taskBase_name",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "task-info" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("span", [_vm._v("任务资源库描述：")]),
            _c("el-input", {
              attrs: { type: "textarea", placeholder: "请输入任务资源库描述" },
              model: {
                value: _vm.taskBase_desc,
                callback: function ($$v) {
                  _vm.taskBase_desc = $$v
                },
                expression: "taskBase_desc",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._m(1),
    _c(
      "section",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "knowledge",
      },
      [
        _c("div", { staticClass: "knowledge-block" }, [
          _c(
            "div",
            { staticClass: "header" },
            [
              _c(
                "el-checkbox",
                {
                  staticClass: "check_all",
                  attrs: { indeterminate: _vm.isIndeterminate },
                  on: { change: _vm.handleCheckAllChange },
                  model: {
                    value: _vm.checkAll,
                    callback: function ($$v) {
                      _vm.checkAll = $$v
                    },
                    expression: "checkAll",
                  },
                },
                [_vm._v("全选")]
              ),
              _c("el-button", { on: { click: _vm.getGroups } }, [
                _vm._v("组合"),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "blocks" },
            [
              _vm.knowledgeBlocks.length
                ? _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.changeBlocks },
                      model: {
                        value: _vm.checkedBlocks,
                        callback: function ($$v) {
                          _vm.checkedBlocks = $$v
                        },
                        expression: "checkedBlocks",
                      },
                    },
                    _vm._l(_vm.knowledgeBlocks, function (check, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          !Array.isArray(check.text)
                            ? _c(
                                "el-checkbox",
                                { attrs: { border: "", label: check } },
                                [
                                  _c("el-input", {
                                    staticClass: "block_text",
                                    attrs: {
                                      id: check.text,
                                      type: "textarea",
                                      placeholder: "请填写知识块",
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.textareaId = check.text
                                      },
                                    },
                                    model: {
                                      value: check.text,
                                      callback: function ($$v) {
                                        _vm.$set(check, "text", $$v)
                                      },
                                      expression: "check.text",
                                    },
                                  }),
                                  _vm.file.identifyType === "term"
                                    ? _c(
                                        "div",
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入生成数量",
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.inputData(check)
                                              },
                                            },
                                            model: {
                                              value: check.num,
                                              callback: function ($$v) {
                                                _vm.$set(check, "num", $$v)
                                              },
                                              expression: "check.num",
                                            },
                                          }),
                                          _c("el-input", {
                                            attrs: {
                                              type: "textarea",
                                              placeholder: "请输入生成要求",
                                            },
                                            model: {
                                              value: check.params,
                                              callback: function ($$v) {
                                                _vm.$set(check, "params", $$v)
                                              },
                                              expression: "check.params",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  check.taskElements &&
                                  check.taskElements.length
                                    ? _c(
                                        "div",
                                        { staticClass: "task-list" },
                                        [
                                          _c("div", [_vm._v("步骤集合如下：")]),
                                          _vm._l(
                                            check.taskElements,
                                            function (task, task_i) {
                                              return _c(
                                                "div",
                                                {
                                                  key: task_i,
                                                  staticClass: "task-row",
                                                },
                                                [
                                                  _c(
                                                    "el-row",
                                                    {
                                                      staticClass:
                                                        "task-detail_row",
                                                    },
                                                    [
                                                      _c(
                                                        "el-col",
                                                        { attrs: { span: 12 } },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "qa-row",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "title-short",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "问题："
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    task
                                                                      .questions[0]
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "qa-row",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "title-short",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "答案："
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    task.answer
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-col",
                                                        { attrs: { span: 12 } },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "qa-row",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "title-long",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "问题意图："
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    task.questionIntent
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "qa-row",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "title-long",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "答案意图："
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    task.answerIntent
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-row",
                                                    [
                                                      _c("div", [
                                                        _vm._v("检查点："),
                                                      ]),
                                                      _vm._l(
                                                        task.checkList,
                                                        function (c, c_i) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: c_i,
                                                              staticClass:
                                                                "check_point",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(c) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  check.questions && check.questions.length
                                    ? _c(
                                        "div",
                                        { staticClass: "question-list" },
                                        [
                                          _c("div", [
                                            _vm._v("生成的问题如下："),
                                          ]),
                                          _vm._l(
                                            check.questions,
                                            function (q, q_i) {
                                              return _c(
                                                "div",
                                                {
                                                  key: q_i,
                                                  staticClass: "question-row",
                                                },
                                                [
                                                  _c(
                                                    "el-row",
                                                    {
                                                      staticClass:
                                                        "question-detail_row",
                                                    },
                                                    [
                                                      _c(
                                                        "el-col",
                                                        { attrs: { span: 12 } },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "qa-row",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "title-short",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "问题："
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    q.question
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "qa-row",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "title-short",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "答案："
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    q.answer
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-col",
                                                        { attrs: { span: 12 } },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "qa-row",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "title-long",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "问题意图："
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    q.questionIntent
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "qa-row",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "title-long",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "答案意图："
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    q.answerIntent
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-row",
                                                    [
                                                      _c("div", [
                                                        _vm._v("检查点："),
                                                      ]),
                                                      _vm._l(
                                                        q.checkPoints,
                                                        function (c, c_i) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: c_i,
                                                              staticClass:
                                                                "check_point",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(c) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c(
                                "el-checkbox",
                                { attrs: { label: check, border: "" } },
                                [
                                  _c(
                                    "section",
                                    { staticClass: "com_knows" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input_know" },
                                        _vm._l(check.text, function (c) {
                                          return _c(
                                            "div",
                                            { key: c.index },
                                            [
                                              _c("el-input", {
                                                staticClass: "block_text",
                                                attrs: {
                                                  id: c.text,
                                                  type: "textarea",
                                                  placeholder: "请填写知识块",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    _vm.textareaId = c.text
                                                  },
                                                },
                                                model: {
                                                  value: c.text,
                                                  callback: function ($$v) {
                                                    _vm.$set(c, "text", $$v)
                                                  },
                                                  expression: "c.text",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        }),
                                        0
                                      ),
                                      check.text.length > 1
                                        ? _c(
                                            "el-button",
                                            {
                                              staticClass: "com_btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.compKnowBlocks(
                                                    index,
                                                    check
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("拆解")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.file.identifyType === "term"
                                    ? _c(
                                        "div",
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入生成数量",
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.inputData(check)
                                              },
                                            },
                                            model: {
                                              value: check.num,
                                              callback: function ($$v) {
                                                _vm.$set(check, "num", $$v)
                                              },
                                              expression: "check.num",
                                            },
                                          }),
                                          _c("el-input", {
                                            attrs: {
                                              type: "textarea",
                                              placeholder: "请输入生成要求",
                                            },
                                            model: {
                                              value: check.params,
                                              callback: function ($$v) {
                                                _vm.$set(check, "params", $$v)
                                              },
                                              expression: "check.params",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  check.taskElements &&
                                  check.taskElements.length
                                    ? _c(
                                        "div",
                                        { staticClass: "task-list" },
                                        [
                                          _c("div", [_vm._v("步骤集合如下：")]),
                                          _vm._l(
                                            check.taskElements,
                                            function (task, task_i) {
                                              return _c(
                                                "div",
                                                {
                                                  key: task_i,
                                                  staticClass: "task-row",
                                                },
                                                [
                                                  _c(
                                                    "el-row",
                                                    {
                                                      staticClass:
                                                        "task-detail_row",
                                                    },
                                                    [
                                                      _c(
                                                        "el-col",
                                                        { attrs: { span: 12 } },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "qa-row",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "title-short",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "问题："
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    task
                                                                      .questions[0]
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "qa-row",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "title-short",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "答案："
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    task.answer
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-col",
                                                        { attrs: { span: 12 } },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "qa-row",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "title-long",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "问题意图："
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    task.questionIntent
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "qa-row",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "title-long",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "答案意图："
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    task.answerIntent
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-row",
                                                    [
                                                      _c("div", [
                                                        _vm._v("检查点："),
                                                      ]),
                                                      _vm._l(
                                                        task.checkList,
                                                        function (c, c_i) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: c_i,
                                                              staticClass:
                                                                "check_point",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(c) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ]
                              ),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "no-data" }, [
                    _vm._v(" 暂无知识块 "),
                  ]),
            ],
            1
          ),
        ]),
      ]
    ),
    _c(
      "div",
      { staticClass: "btn" },
      [
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
          [_vm._v("提交")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("基本信息")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("知识块的组合列表")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }